import React, { useState } from "react";
import "./ChannelPartnerApplySection.css";
import partnerImg from "../assets/partner-visual.png";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const ChannelPartnerApplySection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://driveincarspa.com/submit-channel.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData).toString(),
      });

      const text = await response.text();
      if (response.ok) {
        alert("Form submitted successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        alert("Submission failed. Please try again.");
        console.error(text);
      }
    } catch (err) {
      alert("An error occurred. Please try again later.");
      console.error(err);
    }
  };

  return (
    <section className="channel-section-wrapper">
      <div className="channel-section-left">
        <div className="channel-contact-strip">
          <div className="channel-email-badge">
            <FaEnvelope className="channel-icon" />
            driveincarspa@gmail.com
          </div>
          <div className="channel-phone-badge">
            <FaPhoneAlt className="channel-icon" />
            <div>
              <span className="channel-label">Get Professional Help</span><br />
              <span className="channel-number">+91-8951509309</span>
            </div>
          </div>
        </div>
        <img src={partnerImg} alt="Channel Partner Visual" />
      </div>

      <div className="channel-section-right">
        <h2>
          Become a <strong>Channel Partner</strong>
        </h2>
        <p>
          Join the Drive-In Car Spa network and tap into India’s growing demand
          for fast, reliable, and touchless car wash system…
        </p>
        <h3>JOIN US AS A CHANNEL PARTNER TODAY!</h3>
        <h4>STEP INTO SUCCESS – APPLY AS A PARTNER.</h4>

        <form className="channel-partner-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Your email"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your message"
            rows={3}
            value={formData.message}
            onChange={handleChange}
          />
          <button type="submit">SUBMIT</button>
        </form>
      </div>
    </section>
  );
};

export default ChannelPartnerApplySection;
